import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { schedulesApi, type ScheduleListParams } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function scheduleListQueryOptions(params: ScheduleListParams) {
  return queryOptions({
    queryKey: scheduleKeys.list(params),
    queryFn: () => schedulesApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useSchedules(params: ScheduleListParams) {
  return useQuery(scheduleListQueryOptions(params));
}
